import type { NavItem } from '../components/ScrollerNav/types';

export function isValidTabId(id: string, items: NavItem[]) {
  return Boolean(items.find(item => item.id === id));
}
